import { Component, Input, OnInit, effect } from '@angular/core';
import { HuddlesService } from 'src/app/shared/services/huddle/huddles.service';
import { AccountsService } from 'src/app/shared/services/accounts/accounts.service';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { LtmsWorkflowDataSourceService } from 'src/app/shared/services/data-source/ltms-workflow-data-source.service';
import * as moment from 'moment';
import * as _ from 'lodash';
import { NgIf, NgFor, NgStyle, NgClass, NgTemplateOutlet } from '@angular/common';
import { LtmsLoaderComponent } from '../../../../shared/components/ltms-loader/ltms-loader.component';
import { LtmsErrorComponent } from '../../../../shared/components/ltms-error/ltms-error.component';
import { OverviewTableComponent } from '../../../../shared/components/score/score-overview/sub-component/overview-table/overview-table.component';
import { ActionEditModalComponent } from '../action-edit-modal/action-edit-modal.component';

@Component({
    selector: 'app-all-huddles',
    templateUrl: './all-huddles.component.html',
    styleUrls: ['./all-huddles.component.scss'],
    imports: [NgIf, NgFor, NgStyle, NgClass, LtmsLoaderComponent, NgTemplateOutlet, LtmsErrorComponent, OverviewTableComponent, ActionEditModalComponent]
})
export class AllHuddlesComponent implements OnInit {

  // new variable declaration
  accountId: string = '';
  fromDate: any = null;
  toDate: any = null;
  brandDetails: any = {};
  brandId: string = '';
  pagingDetails: any = {
    start: 0,
    end: 0,
    pageSize: 10,
    pageNumber: 1,
    total: 0,
    totalpages: 1
  }
  pagingButtons: any = {
    isNext: false,
    isPrevious: false,
    isLast: false,
    isFirst: false
  }
  huddleTable: any = {
    header:
      [{
        header: "Title",
        uniqueId: "name",
        width: '700px',
        maxWidth: '700px',
        minWidth: '700px',
        isSortingEnabled: false,
        isClickable: true,
        style: {
          header: 'flex-start',
          row: 'flex-start',
          textWrap: 'wrap'
        },
        textStyle: {
          whiteSpace: 'wrap'
        }
      },
      {
        header: "Date",
        uniqueId: "formated_created_date",
        sortId:'created_date_in_ms',
        width: '200px',
        maxWidth: '200px',
        minWidth: '200px',
        isSortingEnabled: true,
        // isClickable: true,
        style: {
          header: 'flex-end',
          row: 'flex-end',
          textWrap: 'wrap'
        },
        textStyle: {
          whiteSpace: 'wrap'
        }
      },
      {
        header: "Spotlight",
        uniqueId: "spotlights_count",
        width: '200px',
        maxWidth: '200px',
        minWidth: '200px',
        isSortingEnabled: false,
        style: {
          header: 'flex-end',
          row: 'flex-end'
        },
        textStyle: {
          whiteSpace: 'wrap'
        }
      },
      {
        header: "Action plan",
        uniqueId: "actions_count",
        width: '200px',
        maxWidth: '200px',
        minWidth: '200px',
        isSortingEnabled: false,
        style: {
          header: 'flex-end',
          row: 'flex-end'
        }
      },
      {
        header: "Suggestions",
        uniqueId: "escalations_count",
        width: '120px',
        maxWidth: '300px',
        isSortingEnabled: false,
        style: {
          header: 'flex-end',
          row: 'flex-end'
        }
      }
      ],
    rows: []
  };

  defaultSortOn:any={
    header: "Date",
    uniqueId: "formated_created_date",
    sortId:'created_date_in_ms',
    width: '700px',
    maxWidth: '700px',
    minWidth: '700px',
    sort_order:'desc',
    isSortingEnabled: true,
    // isClickable: true,
    style: {
      header: 'flex-end',
      row: 'flex-end',
      textWrap: 'wrap'
    },
    textStyle: {
      whiteSpace: 'wrap'
    }
  }
  selected_level: string = '';
  selected_value: any;
  hierarchyStack: any;

  sortColumn: any = null
  sortDirection: string = 'asc'


  subModuleDetails: any = {
    "spotlights": {
      brandId: null,
      fieldDefinitions: []
    },
    "escalations": {
      brandId: null,
      fieldDefinitions: []
    },
    "actions": {
      brandId: null,
      fieldDefinitions: []
    }
  }

  huddleModuleConfig: any = {}
  managerAccess: any = {}
  tableConfigs: any = {
    "actions": {
      "configs": {
        textWrap: true,
        isRowEditable: true,
        isExternalSort: true
      },
      header: [],
      fixedHeader: [],
      fieldToEdit:[]
    },
    "escalations": {
      "configs": {
        textWrap: true,
        isRowEditable: true,
        isExternalSort: true
      },
      header: [],
      fixedHeader: [],
      fieldToEdit:[]
    },
    "spotlights": {
      "configs": {
        textWrap: true,
        isRowEditable: true,
        isExternalSort: true
      },
      header: [],
      fixedHeader: [],
      fieldToEdit:[]
    }
  }
  columnsConfiguration: any = {}
  showEditModal:boolean =false;
  modalData:any={}
  feedMapping:any ={}
  isMeetingListLoading:boolean = true;
  isMeetingDataAvailable:boolean = false;
  filters: any = {
    sortedOrder: 'desc',
    sortedOnfield: 'created_date'
  }

  moduleValue: any = {}
  huddleDetailFilter: any = {
    limit: 30,
    pageNumber: 1
  }

  rowDataForMeeting = {}
  isDetailsLoading:boolean = true;
  spotlightsMap: any = {}
  activeDetailTab: string = 'spotlights';

  constructor(
    private _huddlesService: HuddlesService,
    private _accountsService: AccountsService,
    private _stateService: AppStateService,
    private _feedService: FeedsService,
    private _workflowDataSource: LtmsWorkflowDataSourceService
  ) {
    effect(() => {
      if (this._stateService.initialized()) {
        const state: any = this._stateService.appState();
        if (state && this.checkRequiredPamater(state)) {

          this.fromDate = state.datePicker.startDate;
          this.toDate = state.datePicker.endDate;
          if (state.hierarchyStack && state.hierarchyStack.length) {
            const index = state.hierarchyStack.length - 1
            this.selected_level = state.hierarchyStack[index].field_id;
            this.selected_value = state.hierarchyStack[index].group_key[0];
          }
          if (this.brandId != state.brandDetails._id) {
            this.brandDetails = state.brandDetails;
            this.brandId = state.brandDetails._id;
            this.accountId = state.accountDetails._id;
            this.managerAccess = this.getManagerAccess(this.brandId)
            this.huddleModuleConfig = _.get(this.brandDetails, "action_management_configuration.huddle.modules");
            this.subModuleDetails.spotlights.brandId = _.get(this.huddleModuleConfig, 'spotlights.config.brand_id', null);
            this.subModuleDetails.actions.brandId = _.get(this.huddleModuleConfig, 'actions.config.brand_id', null);
            this.subModuleDetails.escalations.brandId = _.get(this.huddleModuleConfig, 'escalations.config.brand_id', null);
            this.sortColumn = this.defaultSortOn.sortId || this.defaultSortOn.uniqueId;
            this.sortDirection = this.defaultSortOn.sort_order;
            this.filters.sortedOrder = this.defaultSortOn.sort_order;
            this.getMeetingList();
          }else{
            this.getMeetingList();
          }

        }
      }
    });
  }


  ngOnInit(): void {}

  checkRequiredPamater(state: any) {
    if (state && _.hasIn(state, 'brandDetails') && !_.isEmpty(state.brandDetails) && _.hasIn(state, 'datePicker') && !_.isEmpty(state.datePicker) && _.hasIn(state, 'hierarchyStack') && !_.isEmpty(state.hierarchyStack)) {
      return true;
    } else {
      return false;
    }
  }

  getManagerAccess(brandId) {
    const managerAccesses = _.get(Helpers, 'managerDetails.manager.manager_access', [])
    var accessDetails = _.filter(managerAccesses, function (accessDetails) {
      return (_.get(accessDetails, 'access_key') && _.get(accessDetails, 'brand_id') == brandId);
    });

    return _.get(accessDetails[0], 'access_key')
  }
  
  getMeetingList() {
    this.isMeetingListLoading = true
    this.huddleTable.rows = []
    const params: any = {
      branch_code: this.selected_value,
      branch_level: this.selected_level,
      brand_id: this.brandId,
      from: this.fromDate,
      to: this.toDate,
      meeting_id: null,
      order: this.filters.sortedOrder || 'desc',
      order_by: this.filters.sortedOnfield || 'created_date',
      limit: this.pagingDetails.pageSize,
      page_number: this.pagingDetails.pageNumber,

    }

    this._huddlesService.getMeetingsList(params).subscribe((response: any) => {
      if (_.get(response, 'data.code') == 0 && _.hasIn(response, 'data.meetings') && !_.isEmpty(response.data.meetings)) {
        this.huddleTable.rows = this.prepareMeetingRowData(response.data.meetings);
        let totalMeeting = response.data.meetings_count;
        let meetingCount = (typeof totalMeeting === 'number') ? totalMeeting : totalMeeting.value;
        this.updatePagingDetails(meetingCount,this.pagingDetails.pageNumber)
        if(this.huddleTable.rows && this.huddleTable.rows.length){
          this.isMeetingDataAvailable = true;
        }else{
          this.isMeetingDataAvailable = false;
        }
        this.isMeetingListLoading = false;
      }else{
        this.isMeetingListLoading = false;
        this.isMeetingDataAvailable = false;
      }
    }, (error: any) => {
      console.error("Error occure while try to fetch meetings")
      this.isMeetingListLoading = false;
      this.isMeetingDataAvailable =false;
    })
  }

  prepareMeetingRowData(meetings:any) {
    let meetingList: any = []
    if (meetings && meetings.length) {
      meetingList = _.map(meetings, (meeting: any, index: number) => {
        let rowData: any = {
          "meeting_id": meeting._id,
          "created_date": meeting.created_date,
          "branch_code": meeting.branch_code || "NA",
          "formated_created_date": moment(meeting.created_date).format('DD-MMM-YYYY'),
          "created_date_in_ms": moment(meeting.created_date).valueOf(),
          "name": _.get(meeting, 'params.name', 'NA'),
          "spotlights_count": _.get(meeting, 'params.no_of_spotlights', 0),
          "escalations_count": _.get(meeting, 'params.no_of_escalations', 0),
          "actions_count": _.get(meeting, 'params.no_of_actions', 0)
        }
        return rowData;
      })
    }
    return meetingList
  }

  onRowExpand(row: any) {
    this.huddleTable.rows = _.map(this.huddleTable.rows, (rowData: any) => {
      if (rowData.meeting_id == row.meeting_id) {
        if (rowData.isExpanded) {
          delete rowData.isExpanded;
        } else {
          rowData.isExpanded = true;
        }

      } else {
        delete rowData.isExpanded;
      }
      return rowData;
    })
    this.activeDetailTab = 'spotlights';
    this.filters.meeting_id = row.meeting_id;

    this.getMeetingDetails()
  }

  getMeetingDetails() {
    this.isDetailsLoading = true;
    this.rowDataForMeeting[this.activeDetailTab]=[];
    this.feedMapping = {}
    this.moduleValue = _.get(this.huddleModuleConfig, this.activeDetailTab)
    const brandId: any = _.get(this.subModuleDetails, this.activeDetailTab + '.brandId');
    this.getFieldDefinitions(brandId, this.activeDetailTab).then((fieldDefinitions: any) => {
      this.setColumnConfigration(this.subModuleDetails, brandId, this.activeDetailTab)
      this.getFeedList()
    })

  }

  getFeedList() {
    var universalFilter = {
      "tag_filter": {
        "tag_huddle_meeting_id": {
          "action": "eq",
          "filter_type": "string",
          "values": [this.filters.meeting_id],
          "selected_values": this.filters.meeting_id
        }
      }
    }
    var params = {
      "accountId": this.accountId,
      "brandId": this.moduleValue.config.brand_id,
      "limit": this.huddleDetailFilter.limit,
      "pageNumber": this.huddleDetailFilter.pageNumber,
      "universalFilter": universalFilter
    }
   

    this._feedService.getFeedsByFilter(params).subscribe((response) => {
      if (response && _.get(response, 'data.code') == 0 && !_.isEmpty(response.data.feed)) {
        this.setRowDataDetails(response.data.feed)
        this.isDetailsLoading = false;
      }else{
        this.rowDataForMeeting[this.activeDetailTab]=[];
      }
      this.isDetailsLoading = false;

    },(error:any)=>{
      this.rowDataForMeeting[this.activeDetailTab]=[];
      this.isDetailsLoading = false;
    })

  }

  setRowDataDetails(feedDetails) {
    this.rowDataForMeeting = {};
    var dataEditiblityMode = false;
    if (this.huddleModuleConfig && !_.isEmpty(this.huddleModuleConfig)) {
      const moduleKey = this.activeDetailTab;
      this.rowDataForMeeting[moduleKey] = [];

      _.each(feedDetails, (details: any, key: any) => {
        if (_.get(details, 'litmus_processed_data')) {
          this.feedMapping[details._id]=details;
          var feedId = details._id;
          var feedRowData = Helpers.deepClone(details.litmus_processed_data);
          feedRowData['row_id'] = feedId;
          feedRowData['key'] = feedId;
          feedRowData['meeting_id'] = this.filters.meeting_id;
          if (_.get(this.moduleValue, 'config.is_edit_btn')) {
            feedRowData["editBtn"] = "";
          }

          //huddleDetailsVm.managerAccessKeys
          if (_.get(details, 'litmus_processed_data')) {
            dataEditiblityMode = this.managerAccessCheck(details.feedback_request_data, this.managerAccess);

            if (dataEditiblityMode) {
              feedRowData['editable'] = true;
            } else {
              feedRowData['editable'] = false;
            }

            if (_.get(this.columnsConfiguration[moduleKey], 'columns')) {
              _.each(this.columnsConfiguration[moduleKey]['columns'], function (colValue, colKey) {
                if (_.get(colValue, 'datasource.options.data_to_save_in.display_field') && _.get(colValue, 'datasource.options.data_to_save_in.value_field')) {
                  var columnOptions = colValue.datasource.options;
                  if (_.get(columnOptions, 'value_field') && _.get(columnOptions, 'display_field')) {
                    var dataToShow: any = [];
                    var tagdetail: any = {};
                    const valueField = _.get(columnOptions,'data_to_save_in.value_field');
                    const displayField = _.get(columnOptions,'data_to_save_in.display_field');
                    tagdetail[columnOptions.value_field] = feedRowData[valueField];
                    tagdetail[columnOptions.display_field] = feedRowData[displayField];

                    // feedRowData[datasourceOptions.data_to_save_in.value_field] = tagdetail[columnOptions.value_field];
                    // feedRowData[datasourceOptions.data_to_save_in.display_field] = tagdetail[columnOptions.display_field];
                    feedRowData[colKey] = feedRowData[displayField] || feedRowData[valueField];
                    dataToShow.push(tagdetail);
                    // feedRowData[colKey] = dataToShow;
                  }
                } else {
                  colKey
                }
              });
            }
          }
          this.rowDataForMeeting[moduleKey].push(feedRowData);
          
          // huddleDetailsVm.pagerBusy = false;
          // huddleDetailsVm.pageRedirecting = false;
        }
      });
    }
  }

  managerAccessCheck(tagPrivateData, accessKeys) {
    let isAccessExist: boolean = false;
    _.each(accessKeys, (accessValues: any, key: string) => {
      if (tagPrivateData['tag_private_group_' + key] && accessValues['values'].indexOf(tagPrivateData['tag_private_group_' + key][0]) >= 0) {
        isAccessExist = true;
      }
    })

    return isAccessExist;
  }

  getFieldDefinitions(brandId: string, modulename: string) {
    return new Promise((resolve, reject) => {
      if (!_.hasIn(this.subModuleDetails, modulename + '.fieldDefinitions') || _.isEmpty(this.subModuleDetails[modulename].fieldDefinitions)) {
        this._accountsService.getBrandDetail(brandId).subscribe((response) => {
          if (response && _.get(response, 'data.code') == 0 && _.hasIn(response, 'data.brand') && !_.isEmpty(response.data.brand)) {
            const brandDetails = _.get(response, 'data.brand');
            this.subModuleDetails[modulename].brandDetails = brandDetails;
            this.subModuleDetails[modulename].fieldDefinitions = _.get(brandDetails, 'field_definitions')
            resolve(this.subModuleDetails[modulename])
          } else {
            console.error("Error while trying to fetch huddle brand details.")
          }
        }, (error) => {
          resolve({})
          console.error("Error while trying to fetch huddle brand details.", error)
        })
      } else {
        resolve(this.subModuleDetails[modulename].fieldDefinitions)
      }
    })
  }

  setColumnConfigration(moduleConfigs: any, brandId: any, modulename: string) {

    _.each(moduleConfigs, (config: any, configKey: string) => {
      this.columnsConfiguration[configKey] = {
        "row_height": "85px",
        "max_letter_allowed_in_col": 120,
        "is_open_modal": true,
        "is_row_clickable": true,
        "brand_id": this.huddleModuleConfig[configKey]['config']['brand_id'],
        "columns": {}
      };
      if (config.brand_id != brandId && configKey == modulename) {
        this.columnsConfiguration[configKey]['columns'] = {}
      }
      if (config.fieldDefinitions && config.fieldDefinitions.length) {
        _.each(config.fieldDefinitions, (value: any, key: any) => {
          //need to check show_in_inbox_detail to show or hide the content in table row.
          if ((_.get(value, 'custom_parameter_type') == 4 && (_.get(value, 'show_in_inbox_detail') && (_.get(value, 'data_type') != 'date')) || _.get(value, 'group_id') == null)) {
            // For expression we need to retrive data and save it in configuration for table dedit data.
            if (_.get(value, 'datasource.type') == 3 && _.get(value, 'datasource.expression')) {
              this._workflowDataSource.getData(value["datasource"], (error, data) => {
                if (!error) {
                  var textIdToDisplay = _.get(value, "datasource.options.display_field");
                  var valueIdforText = _.get(value, "datasource.options.value_field");
                  if (textIdToDisplay && valueIdforText) {

                    var options = _.map(data.data, function (option) {
                      var optionValue = {};
                      optionValue[textIdToDisplay] = option[textIdToDisplay];
                      optionValue[valueIdforText] = option[valueIdforText];
                      return (optionValue);
                    });

                    // value["datasource"]['type'] = 4;
                    if (!_.get(value, 'datasource.options')) {
                      value["datasource"]['options'] = {};
                    }
                    value["datasource"]['options']['values'] = [];
                    value["datasource"]['options']['values'] = options;
                    //Status options values : 
                    // "options": {
                    //    "values": [{ "uuid": "1236", "name": "Open" },
                    //      { "uuid": "1234", "name": "Closed" },
                    //      { "uuid": "1235", "name": "Escalated" }
                    //      ]
                    //  }
                  }
                }
              });
            }
            this.columnsConfiguration[configKey]['columns'][value.field_id] = value;
          }
        });
        let columnToPrepare: any = Helpers.deepClone(Object.values(this.columnsConfiguration[configKey]['columns']));
        columnToPrepare = _.filter(columnToPrepare, (column: any) => {
          return (!column.is_huddle_information && column.group_id && column.field_id != "editBtn");
        })
        this.tableConfigs[configKey].fieldToEdit = Helpers.deepClone(columnToPrepare);
        this.tableConfigs[configKey].header = _.map(columnToPrepare, (field: any,index:number) => {
          let column: any = {
            header: field.title || field.name,
            uniqueId: field.field_id,
            width: this.getColumnWidth(field),
            maxWidth: this.getColumnWidth(field),
            minWidth: this.getColumnWidth(field),
            isSortingEnabled: false,
            data_type: field.data_type,
            style: {
              header: 'flex-start',
              row: 'flex-start',
              textWrap: 'wrap'//(_.get(field, 'dom_options.type') == "multi-line") ? 'wrap' : ''
            },
            textStyle: {
              whiteSpace: 'wrap'//(_.get(field, 'dom_options.type') == "multi-line") ? 'wrap' : ''
            }
          }
          if (field.isSortable) {
            if (field.data_type == "date") {
              column.sortId = field.field_id + "_in_ms";
              column.sort_order = 'desc';
              this.tableConfigs.defaultSortOnColumn = column;
            }
            column.isSortingEnabled = true;
          }
          return column

        })
      }

    });

    this.getSpotlightFieldDef(this.columnsConfiguration);
  }

  getColumnWidth(column: any) {
    if(column.field_id == "tag_meeting_name" ){
      return '440px';
    }else if(column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_theme_1"){
      return '270px';
    }else if(column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_sub_reason_1" || column.field_id == "tag_ltms_huddle_e4147198-670e-4ced-b98e-fc4679f57d8f81-11" || column.field_id == "tag_ltms_huddle_e256eace-6abf-4960-a0ea-ec85abd0addd"){
      return '300px';
    }else if(column.field_id == "tag_ltms_huddle_3082eef8-baba-409d-b05e-99e960d760d889-44"){
      return '120px';
    }else if (column.field_id == "tag_ltms_huddle_82797a2f-616e-4f2f-b4ee-808238baf0e89") {
      return '230px';
    } else if (column.field_id == "tag_ltms_huddle_suggestions_for_process_imporvement_product_and_function_1") {
      return '210px';
    } else if (_.get(column, 'dom_options.type') == "multi-line") {
      return '600px';
    } else if (column.data_type == 'date') {
      return '150px';
    } else {
      return '200px';
    }
  }
  
  getSpotlightFieldDef(columnsConfiguration: any) {
    if (_.get(columnsConfiguration, 'spotlights.columns')) {
      var columnDetails = Helpers.deepClone(columnsConfiguration.spotlights.columns);
      _.each(columnDetails, (value, key) => {
        // (_.get(value, 'dom_options.type') == "single-line" &&
        if (_.get(value, 'datasource.options.data_to_save_in.display_field')) {

          this.spotlightsMap["header_id"] = value['datasource']['options']['data_to_save_in']['display_field'] || "NA";
        }
        if (_.get(value, 'dom_options.type') == "multi-line") {
          this.spotlightsMap["content_id"] = key;
        }
      });
    }
  }

  getSortIcon(column: any): string {
    if ((this.sortColumn === column.uniqueId) || (this.sortColumn === column.sortId)) {
      return this.sortDirection === 'asc' ? 'assets/images/arrow-up.svg' : 'assets/images/arrow.svg';
    }
    return 'assets/images/arrow-up.svg';
  }

  onSort(column: any) {
    const sortKey = column.sortId || column.uniqueId
    if (this.sortColumn === sortKey) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = sortKey;
      this.sortDirection = this.sortDirection === 'desc' ? 'asc' : 'desc';
    }

    this.filters.sortedOrder = this.sortDirection
    // this.pagingDetails.pageNumber = 1;
    this.getMeetingList();
  }

  updatePagingDetails(totalfeeds: number, pageNumber: number) {
    if (totalfeeds > this.pagingDetails.pageSize) {
      pageNumber = (pageNumber > 0) ? pageNumber : 1;
      let start = (pageNumber > 0) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + 1 : 1;
      let end = (pageNumber > 0) ? (pageNumber * this.pagingDetails.pageSize) : this.pagingDetails.pageSize;
      end = (pageNumber >= this.pagingDetails.totalpages) ? ((pageNumber - 1) * this.pagingDetails.pageSize) + this.huddleTable.rows.length : end;
      this.pagingDetails = {
        start: start,
        end: end,
        pageSize: 10,
        pageNumber: pageNumber,
        total: totalfeeds,
        totalpages: Math.ceil(totalfeeds / 10)
      }
    } else {
      this.pagingDetails = {
        start: (totalfeeds > 0) ? 1 : 0,
        end: (totalfeeds > 0) ? totalfeeds : 0,
        pageSize: 10,
        pageNumber: 1,
        total: (totalfeeds > 0) ? totalfeeds : 0,
        totalpages: 1
      }
    }
    this.pagingDetails.total = totalfeeds;
    this.pagingButtons.isNext = false;
    this.pagingButtons.isFirst = false;
    this.pagingButtons.isPrevious = false;
    this.pagingButtons.isLast = false;

    if (this.pagingDetails.pageNumber < this.pagingDetails.totalpages) {
      this.pagingButtons.isNext = true;
      this.pagingButtons.isLast = true;
    }

    if (this.pagingDetails.pageNumber > 1) {
      this.pagingButtons.isFirst = true;
      this.pagingButtons.isPrevious = true;
    }

    if (this.pagingDetails.total < this.pagingDetails.pageSize) {
      this.pagingButtons.isNext = false;
      this.pagingButtons.isFirst = false;
      this.pagingButtons.isPrevious = false;
      this.pagingButtons.isLast = false;
    }
  }

  paginateFeedList(pagingType: string) {
    if (pagingType == 'next') {
      this.pagingDetails["pageNumber"]++;
    } else if (pagingType == 'previous') {
      this.pagingDetails["pageNumber"]--;
    } else if (pagingType == 'first') {
      this.pagingDetails["pageNumber"] = 1;
    } else if (pagingType == 'last') {
      this.pagingDetails["pageNumber"] = this.pagingDetails.totalpages;
    }
    this.getMeetingList()
  }

  editMeetingDetail(row: any) {
      this.modalData = {
        "fieldDefinitionsForList": _.get(this.subModuleDetails,this.activeDetailTab+'.fieldDefinitions') ,
        "fieldDefinitions": _.get(this.tableConfigs,this.activeDetailTab+'.fieldToEdit'),
        "brandDetails": _.get(this.subModuleDetails, this.activeDetailTab+".brandDetails"),
        "issueDetail": this.feedMapping[row.row_id],
        "dataToEdit": row,
        "mode": "Update",
        'modalHeader': (this.activeDetailTab == 'actions')?"Action Plan":"Suggestion"
      }
      this.showEditModal = true
    }

  closeEditModal(){
    this.modalData = {}
    this.showEditModal = false;
  }

  cancelEdit(){
    this.modalData = {}
    this.showEditModal = false;
  }

  reloadList(event:any){
    this.getMeetingDetails()
  }

  isEllipsisActive(card: any) {
    const id = 'statement-' + card.key;
    const el = document.getElementById(id);
    if (card.showMore) {
      return true
    } else if (el) {
      return (el.offsetHeight < el.scrollHeight)
    } else {
      return false
    }

  }

  changeCardView(event: any, card: any) {
    event.preventDefault();
    if (card.showMore) {
      card.showMore = false;
    } else {
      card.showMore = true
    }
  }

  changeDetailTab(tabname: string) {
    this.activeDetailTab = tabname;
    this.getMeetingDetails();
  }
}
